import React from 'react';
import { useGame } from '../context/GameContext';
import './AchievementPopup.css'; // Reuse the same CSS file

const XPGainPopup = () => {
  const { showXPGain } = useGame();

  if (!showXPGain) return null;

  return (
    <div className="xp-gain-popup">
      <div className="xp-gain-content">
        +{showXPGain} XP
      </div>
    </div>
  );
};

export default XPGainPopup;
